export default __webpack_public_path__ + "static/media/sd-accommodation-white.1a28930e.png";